import React, { useEffect, useState } from 'react';
import { Channel } from '@food/sync';
import { loggedContext } from '../utils/loggedContext';
import { getValidToken } from '../logic/auth';
var Provider = loggedContext.Provider;
var localListener = new Channel('@food/auth');
export var AuthContext = function (_a) {
    var children = _a.children;
    var _b = useState(getValidToken()), userKey = _b[0], setUserKey = _b[1];
    useEffect(function () {
        localListener.onmessage = function (ev) {
            var data = ev.data;
            if (data.type === 'USER_CHANGED' && data.args && data.args.newUser) {
                if (data.args.newUser) {
                    setUserKey(getValidToken());
                }
                else {
                    setUserKey(null);
                }
            }
        };
    });
    return React.createElement(Provider, { value: userKey }, children);
};
//# sourceMappingURL=AuthContext.js.map